module.exports = __webpack_public_path__ + "img/信阳市政策计算器平台.4c831545.png";